// Sansara mark — the blue line-art "geometric S in a squircle".
// Rendered from an optimized PNG (transparent background, served from /public)
// so the blue outline reads correctly on both light and dark surfaces with no
// white box behind it.
//
// E1 (founder, 2026-10-20: "the logo when logged in … is not clear, it seems
// much thicker lines"). The web PNGs had been drawn from an older, heavier
// artwork — their stroke was ~4.7% of the mark against ~3.1% on the phone's
// master (mobile/assets/splash-icon.png). All three sizes are now resampled
// from that master, so web and phone show the same mark, and each screen
// density gets its own file instead of a 192px image squeezed into 24px.
import { useT } from '../i18n';

export function LogoMark({ size = 42, className = '' }: { size?: number; className?: string }) {
  const t = useT();
  return (
    <img
      src="/sansara-mark.png"
      srcSet="/sansara-mark.png 1x, /sansara-mark-2x.png 2x, /sansara-mark-3x.png 3x"
      width={size}
      height={size}
      alt=""
      aria-label={t('Sansara logo')}
      loading="eager"
      decoding="async"
      className={className}
      style={{ width: size, height: size, flexShrink: 0, display: 'block' }}
    />
  );
}

export function LogoWordmark({ className = '' }: { className?: string }) {
  // size:42 ≈ +5% over the previous 40px so the mark visually encloses the full
  // "Sansara + Your Eternal Charioteer" wordmark block.
  const t = useT();
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      <LogoMark size={42} />
      <span className="flex flex-col leading-none">
        <span className="font-display text-xl font-bold tracking-tight">Sansara</span>
        {/* Tagline: hidden on narrow mobile so the sticky header stays compact. */}
        <span className="mt-0.5 hidden text-xs font-medium tracking-wide text-ink-faint dark:text-slate-400 sm:block">
          {t('Your Eternal Charioteer')}
        </span>
      </span>
    </span>
  );
}
